import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import ContentLoader from "react-content-loader";
import AddColor from "./utilities/AddColor";
import Button from "./utilities/Button";
import loading from "../img/loading.svg";
import bcrypt from "bcryptjs";
const TableLoader = () => (
  <ContentLoader
    height={200}
    width={400}
    speed={2}
    primaryColor={"#f3f3f3"}
    secondaryColor={"#ecebeb"}
  >
    <rect
      x="101"
      y="16.05"
      rx="5"
      ry="5"
      width="220"
      height="16.299999999999997"
    />
    <rect x="101" y="50" rx="5" ry="5" width="220" height="10" />
    <rect x="101" y="74" rx="5" ry="5" width="220" height="10" />
    <rect x="100" y="100" rx="5" ry="5" width="220" height="10" />
  </ContentLoader>
);

class Others extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      daysAhead: null,
      baseDuration: null,
      infoText: null,
      password: "",
      oldPassword: "",
      minTimePlugin: null,
      minTimeAdmin: null,
      maxTimePlugin: null,
      maxTimeAdmin: null,
      cancellationDelay: null,
      doneMsg: false
    };
  }

  handleDaysAhead = event => {
    this.setState(
      {
        daysAhead: parseInt(event.target.value, 10)
      },
      this.saveOption
    );
  };
  handleInfoText = event => {
    this.setState(
      {
        infoText: event.target.value
      },
      this.saveOption
    );
  };

  handleBaseDuration = event => {
    this.setState(
      {
        baseDuration: parseInt(event.target.value, 10)
      },
      this.saveOption
    );
  };
  handleMinTimeAdmin = event => {
    this.setState(
      {
        minTimeAdmin: parseInt(event.target.value, 10)
      },
      this.saveOption
    );
  };
  handleMaxTimeAdmin = event => {
    this.setState(
      {
        maxTimeAdmin: parseInt(event.target.value, 10)
      },
      this.saveOption
    );
  };
  handleMinTimePlugin = event => {
    this.setState(
      {
        minTimePlugin: parseInt(event.target.value, 10)
      },
      this.saveOption
    );
  };
  handleMaxTimePlugin = event => {
    this.setState(
      {
        maxTimePlugin: parseInt(event.target.value, 10)
      },
      this.saveOption
    );
  };
  handleCancellationDelay = event => {
    this.setState(
      {
        cancellationDelay: parseInt(event.target.value, 10)
      },
      this.saveOption
    );
  };

  saveOption = () => {
    const options = this.props.getDoctorOptionsQuery.allOptionses[0];
    const id = options.id;
    const baseDuration = this.state.baseDuration || options.baseDuration;
    const daysAhead = this.state.daysAhead || options.daysAhead;
    const infoText = this.state.infoText || options.infoText;
    const minTimeAdmin = this.state.minTimeAdmin || options.minTimeAdmin;
    const maxTimeAdmin = this.state.maxTimeAdmin || options.maxTimeAdmin;
    const minTimePlugin = this.state.minTimePlugin || options.minTimePlugin;
    const maxTimePlugin = this.state.maxTimePlugin || options.maxTimePlugin;
    const cancellationDelay =
      this.state.cancellationDelay || options.cancellationDelay;

    this.props
      .updateOptions({
        variables: {
          id,
          baseDuration,
          daysAhead,
          infoText,
          minTimeAdmin,
          maxTimeAdmin,
          minTimePlugin,
          maxTimePlugin,
          cancellationDelay
        }
      })
      .catch(e => {
        console.error("update option", e);
      });
  };
  handleDeleteColor = id => {
    this.props
      .deleteColor({
        variables: { id }
      })
      .then(res => {
        this.props.getColors.refetch();
      })
      .catch(e => {
        console.error("delete color", e);
      });
  };
  handleSavePassword = e => {
    e.preventDefault();
    const id = this.props.doctorId;
    let pass = this.state.password;
    let oldPass = this.state.oldPassword;
    this.setState({
      loading: true
    });
    if (pass.length > 0 && oldPass.length > 0) {
      bcrypt
        .compare(oldPass, this.props.getDoctorPassword.User.password)
        .then(passwordCorrect => {
          if (passwordCorrect) {
            //update user with new password
            const SALT_ROUNDS = 10;
            const salt = bcrypt.genSaltSync(SALT_ROUNDS);
            pass = bcrypt.hash(pass, salt).then(password => {
              this.props
                .updateUserMutationWithPassword({
                  variables: { id, password }
                })
                .then(() => {
                  this.setState(
                    {
                      loading: false,
                      errorPass: false,
                      doneMsg: true,
                      oldPassword: "",
                      password: ""
                    },
                    this.props.getDoctorPassword.refetch
                  );
                })
                .catch(e => {
                  this.setState({
                    loading: false,
                    errorPass: true,
                    doneMsg: false
                  });
                  console.error("update user", e);
                });
            });
          } else {
            this.setState({ loading: false, errorPass: true, doneMsg: false });
          }
        });
    } else {
      this.setState({ loading: false, errorPass: true, doneMsg: false });
    }
  };
  render() {
    if (
      this.props.getDoctorOptionsQuery.loading ||
      this.props.getDoctorPassword.loading ||
      this.props.getColors.loading
    ) {
      return (
        <div className="columns  is-centered">
          <div className="column is-4 has-text-centered">
            <TableLoader />
          </div>
        </div>
      );
    } else {
      const option = this.props.getDoctorOptionsQuery.allOptionses[0];
      return (
        <div>
          <h2 className="title">Paramètres personnels</h2>
          <h6 className="subtitle is-6">
            Ces paramètres sont propres à votre agenda
          </h6>
          <p className="p-with-input">
            Les rendez-vous peuvent être pris avec{" "}
            <input
              className="input"
              type="number"
              style={{ width: "6ch" }}
              value={this.state.daysAhead || option.daysAhead}
              onChange={this.handleDaysAhead}
            />{" "}
            jours d'avance.
          </p>
          <p className="p-with-input">
            Un rendez-vous de base dure:{" "}
            <input
              className="input"
              type="number"
              style={{ width: "6ch" }}
              value={this.state.baseDuration || option.baseDuration}
              onChange={this.handleBaseDuration}
            />{" "}
            minutes.
          </p>
          <p className="p-with-input">
            Un patient peut annuler un RdV avec:{" "}
            <input
              className="input"
              type="number"
              style={{ width: "6ch" }}
              value={this.state.cancellationDelay || option.cancellationDelay}
              onChange={this.handleCancellationDelay}
            />{" "}
            heures d'avance.
          </p>
          <br />
          <p className="p-with-input">
            Le calendrier d'<strong>administrateur</strong> commence à :{" "}
            <input
              className="input"
              type="number"
              min="0"
              max="24"
              style={{ width: "6ch" }}
              value={this.state.minTimeAdmin || option.minTimeAdmin}
              onChange={this.handleMinTimeAdmin}
            />{" "}
            heures.
          </p>
          <p className="p-with-input">
            Le calendrier d'<strong>administrateur</strong> termine à :{" "}
            <input
              className="input"
              type="number"
              min="0"
              max="24"
              style={{ width: "6ch" }}
              value={this.state.maxTimeAdmin || option.maxTimeAdmin}
              onChange={this.handleMaxTimeAdmin}
            />{" "}
            heures.
          </p>
          <br />
          <p className="p-with-input">
            Le calendrier du <strong>plugin</strong> commence à :{" "}
            <input
              className="input"
              type="number"
              min="0"
              max="24"
              style={{ width: "6ch" }}
              value={this.state.minTimePlugin || option.minTimePlugin}
              onChange={this.handleMinTimePlugin}
            />{" "}
            heures.
          </p>
          <p className="p-with-input">
            Le calendrier du <strong>plugin</strong> termine à :{" "}
            <input
              className="input"
              type="number"
              min="0"
              max="24"
              style={{ width: "6ch" }}
              value={this.state.maxTimePlugin || option.maxTimePlugin}
              onChange={this.handleMaxTimePlugin}
            />{" "}
            heures.
          </p>
          <br />
          <p>
            Texte Infoscreen pour le patient:{" "}
            <textarea
              className="textarea"
              cols="5"
              rows="5"
              value={this.state.infoText || option.infoText}
              onChange={this.handleInfoText}
            />
          </p>
          <hr />
          <h2 className="title">Paramètres généraux</h2>
          <h6 className="subtitle is-6">
            Ces paramètres sont partagés avec les autres médecins
          </h6>
          <br />
          <h3 className="title  is-4">Couleurs</h3>
          {this.props.getColors.allColors.map(color => (
            <p key={color.id}>
              {" "}
              <span
                className="tag"
                style={{
                  backgroundColor: color.color,
                  minWidth: "80px"
                }}
              >
                {color.color}
              </span>{" "}
              <a onClick={() => this.handleDeleteColor(color.id)}> supprimer</a>
            </p>
          ))}
          <AddColor refetch={this.props.getColors.refetch} />
          <hr />
          <h2 className="title">Votre compte</h2>
          <h6 className="subtitle is-6">
            Ici vous pouvez changer votre mot de passe
          </h6>
          <div className="columns">
            <div className="column is-6">
              <form onSubmit={this.handleSavePassword}>
                <div className="field">
                  <label className="label">Ancien mot de passe</label>
                  <div className="control">
                    <input
                      className={`input  ${this.state.errorPass
                        ? "is-danger"
                        : ""}`}
                      type="password"
                      value={this.state.oldPassword}
                      onChange={e =>
                        this.setState({ oldPassword: e.target.value })}
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Nouveau mot de passe</label>
                  <div className="control">
                    <input
                      className={`input  ${this.state.errorPass
                        ? "is-danger"
                        : ""}`}
                      type="password"
                      value={this.state.password}
                      onChange={e =>
                        this.setState({ password: e.target.value })}
                    />
                  </div>
                </div>
                <div className="field  has-text-centered">
                  {this.state.loading ? (
                    <figure
                      style={{
                        marginBottom: "-10px"
                      }}
                      className="image is-32x32"
                    >
                      <img alt="loading" src={loading} />
                    </figure>
                  ) : null}

                  <Button
                    text="Sauvegarder mot de passe"
                    type="submit"
                    disabled={this.state.loading}
                  />
                  {this.state.errorPass ? (
                    <p className="has-text-danger">
                      Une erreur est survenue! Vérifiez les champs.
                    </p>
                  ) : null}
                  {this.state.doneMsg ? (
                    <p className="has-text-success">
                      Votre mot de passe a été mis à jour
                    </p>
                  ) : null}
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    }
  }
}

/*
  authenticateUser = async () => {
    const { email, password } = this.state;

    const response = await this.props.authenticateUserMutation({
      variables: { email, password }
    });
    localStorage.setItem(
      "graphcoolToken",
      response.data.authenticateUser.token
    );
    this.props.history.replace("/");
  };
}
*/

const GET_DOCTOR_OPTIONS_QUERY = gql`
  query GetDoctorOptionsQuery($doctorId: ID!) {
    allOptionses(filter: { doctor: { id: $doctorId } }) {
      id
      baseDuration
      daysAhead
      infoText
      minTimePlugin
      maxTimePlugin
      minTimeAdmin
      maxTimeAdmin
      cancellationDelay
    }
  }
`;
const GET_DOCTOR_PASSWORD = gql`
  query GetDoctorPassword($doctorId: ID!) {
    User(id: $doctorId) {
      id
      password
      name
    }
  }
`;
const GET_COLORS_QUERY = gql`
  query {
    allColors {
      id
      color
    }
  }
`;

const DELETE_COLOR_MUTATION = gql`
  mutation DeleteColor($id: ID!) {
    deleteColor(id: $id) {
      id
    }
  }
`;
const UPDATE_OPTIONS_MUTATION = gql`
  mutation UpdateOptions(
    $id: ID!
    $baseDuration: Int!
    $daysAhead: Int!
    $infoText: String
    $minTimePlugin: Int!
    $minTimeAdmin: Int!
    $maxTimePlugin: Int!
    $maxTimeAdmin: Int!
    $cancellationDelay: Int!
  ) {
    updateOptions(
      id: $id
      baseDuration: $baseDuration
      daysAhead: $daysAhead
      infoText: $infoText
      minTimePlugin: $minTimePlugin
      minTimeAdmin: $minTimeAdmin
      maxTimePlugin: $maxTimePlugin
      maxTimeAdmin: $maxTimeAdmin
      cancellationDelay: $cancellationDelay
    ) {
      id
    }
  }
`;
const UPDATE_USER_PASSWORD = gql`
  mutation updateUserMutationPassword($id: ID!, $password: String) {
    updateUser(id: $id, password: $password) {
      id
    }
  }
`;
export default compose(
  graphql(GET_DOCTOR_OPTIONS_QUERY, {
    name: "getDoctorOptionsQuery",
    options: ({ doctorId }) => ({
      variables: { doctorId },
      fetchPolicy: "network-only"
    })
  }),
  graphql(GET_DOCTOR_PASSWORD, {
    name: "getDoctorPassword",
    options: ({ doctorId }) => ({
      variables: { doctorId },
      fetchPolicy: "network-only"
    })
  }),
  graphql(GET_COLORS_QUERY, {
    name: "getColors"
  }),
  graphql(UPDATE_OPTIONS_MUTATION, {
    name: "updateOptions"
  }),
  graphql(DELETE_COLOR_MUTATION, {
    name: "deleteColor"
  }),
  graphql(UPDATE_USER_PASSWORD, {
    name: "updateUserMutationWithPassword"
  })
)(Others);



// WEBPACK FOOTER //
// ./src/components/Others.js